import API from "@/API";

const SET_PRELOADER = "SET_PRELOADER";
const SET_META = "SET_META";
const SET_LIST = "SET_LIST";
const SET_TEXT_SEARCH = "SET_TEXT_SEARCH";
const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";

const defaultState = () => {
  return {
    list: "",
    pagination: {
      current: 1,
      totalPages: 1,
      totalResults: 1
    },
    sort: {
      fields: ["created_at"],
      desc: [true]
    },
    textSearch: "",
    preloader: false
  };
};

export default {
  namespaced: true,

  state: {
    pending: { ...defaultState() },
    in_training: { ...defaultState() },
    training_completed: { ...defaultState() },
    training_incompleted: { ...defaultState() }
  },

  actions: {
    async listAll({ state, commit }, status) {
      const currentStatus = { status: status };

      commit("SET_PRELOADER", { ...currentStatus, preloader: true });

      try {
        const result = await API.Professionals.index(
          state[status].pagination.current,
          state[status].sort,
          state[status].textSearch,
          [{ name: "professional_training_status", value: status }]
        );

        commit("SET_META", { ...currentStatus, meta: result.meta });
        commit("SET_LIST", { ...currentStatus, list: result.data });
      } catch (e) {
        throw e;
      }

      commit("SET_PRELOADER", { ...currentStatus, preloader: false });
    },

    async sendNotification(_, data) {
      try {
        await API.Notifications.create(data);
      } catch (e) {
        throw e;
      }
    },

    setTextSearch({ state, commit, dispatch }, textSearch) {
      Object.keys(state).forEach(state => {
        const currentStatus = { status: state };

        commit("SET_TEXT_SEARCH", { ...currentStatus, textSearch: textSearch });
        commit("SET_CURRENT_PAGE", { ...currentStatus, page: 1 });

        dispatch("listAll", state);
      });
    },

    setCurrentPage({ commit, dispatch }, state, page) {
      commit("SET_CURRENT_PAGE", { status: state, page: page });
      dispatch("listAll", state);
    }
  },

  mutations: {
    [SET_PRELOADER](state, { status, preloader }) {
      state[status].preloader = preloader;
    },

    [SET_META](state, { status, meta }) {
      state[status].pagination.totalPages = meta.page_count;
      state[status].pagination.totalResults = meta.record_count;
    },

    [SET_LIST](state, { status, list }) {
      state[status].list = list;
    },

    [SET_TEXT_SEARCH](state, { status, textSearch }) {
      state[status].textSearch = textSearch;
    },

    [SET_CURRENT_PAGE](state, { status, page }) {
      state[status].current = page;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/professionalTrainingFlow.js